import { render, staticRenderFns } from "./ProcessesOrgChart.vue?vue&type=template&id=b2faa7f0"
import script from "./ProcessesOrgChart.vue?vue&type=script&lang=js"
export * from "./ProcessesOrgChart.vue?vue&type=script&lang=js"
import style0 from "./ProcessesOrgChart.vue?vue&type=style&index=0&id=b2faa7f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports